import { createStyles, StyledComponentProps, withStyles } from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import * as React from 'react';
import { IEntity } from '../../../main/entities';
import { mg } from '../../../mg/mg';

const styles = createStyles({
	dimmed: {
		filter: 'opacity(50%)',
	},
	element: {
		paddingLeft: 5,
		paddingRight: 5,
	},
	marker: {
		color: '#00F',
	},
});

interface NameSeachCompElementProps {
	type: string
	string: string
}

@observer class _NameSeachCompElement extends React.Component<NameSeachCompElementProps & StyledComponentProps> {
	render() {
		const {classes, type, string} = this.props;
		const s = <span key="s">{string}</span>;
		const t = <span key="t" className={classes!.marker}>†</span>;
		const t2 = <span key="t2" className={classes!.marker}>†</span>;
		const f = (...x: Array<JSX.Element>) => <span className={classes!.element}>{x}</span>;
		switch (type) {
		case 'STRING': return f(s);
		case 'WORD_START': return f(t, s);
		case 'WORD': return f(t, s, t2);
		}
	}
}

const NameSeachCompElement = withStyles(styles)(_NameSeachCompElement);

interface NameSeachCompProps {
	dimmed?: boolean,
	entity: IEntity
	columnName: string
}

@observer class _NameSeachComp extends React.Component<NameSeachCompProps & StyledComponentProps> {
	render() {
		const {classes, entity, columnName, dimmed} = this.props;
		const json = entity[columnName];
		const nameSearch = mg.parseJson(json);
		const className = dimmed ? classes!.dimmed : '';
		return <span className={className}>{
			nameSearch.elements.map((e, i) => <NameSeachCompElement key={i} type={e.type} string={e.string}/>)
		}</span>;
	}
}

export const NameSeachComp = withStyles(styles)(_NameSeachComp);
